export default __webpack_public_path__ + "static/media/Resilience.74b5b293.svg";